import React from 'react';
import { SimpleGrid, Paper, Text } from '@mantine/core';

// Reusable Seat Grid Component
// Enforces 10 columns for standard cinema layout
const SeatGrid = ({ seats, onSeatClick, readOnly = false }) => {
    // Sort seats by seatNumber (A1, A10, A2... alphabetical sort is tricky, need natural sort)
    // Assuming format "RowNumber" e.g. A1, B10.
    const sortedSeats = [...seats].sort((a, b) => {
        const rowA = a.seatNumber.charAt(0);
        const rowB = b.seatNumber.charAt(0);
        if (rowA !== rowB) return rowA.localeCompare(rowB);
        const numA = parseInt(a.seatNumber.substring(1));
        const numB = parseInt(b.seatNumber.substring(1));
        return numA - numB;
    });

    return (
        <SimpleGrid
            cols={10} // Fixed 10 columns for "Oh wa yeol"
            spacing="xs"
            verticalSpacing="xs"
            style={{ maxWidth: 800, margin: '0 auto' }}
        >
            {sortedSeats.map((seat) => {
                const isReserved = seat.reserved || (seat.status === 'occupied'); // Handle both structures if any
                const isSelected = seat.selected;

                // Determine Styles
                let bgColor = '#1c1c1e';
                let borderColor = '#333';
                let cursor = readOnly ? 'default' : 'pointer';
                let textColor = 'white';

                if (isReserved) {
                    bgColor = '#111'; // Very dark/disabled look
                    borderColor = '#222';
                    cursor = 'not-allowed';
                    textColor = 'dimmed';
                } else if (isSelected) {
                    bgColor = '#0071e3'; // Apple Blue
                    borderColor = '#0071e3';
                }

                // If ReadOnly and Reserved -> maybe Red? Or keep standard 'occupied' look?
                // User wants to see "Situation". Standard occupied look is fine.

                return (
                    <Paper
                        key={seat.id}
                        radius="md"
                        p={0}
                        style={{
                            backgroundColor: bgColor,
                            border: `1px solid ${borderColor}`,
                            height: 45, // Compact square
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: cursor,
                            transition: 'all 0.2s',
                            opacity: isReserved && !readOnly ? 0.6 : 1
                        }}
                        onClick={() => {
                            if (readOnly || isReserved) return;
                            if (onSeatClick) onSeatClick(seat);
                        }}
                    >
                        <Text size="xs" weight={600} color={textColor}>
                            {seat.seat_number || seat.seatNumber}
                        </Text>
                    </Paper>
                );
            })}
        </SimpleGrid>
    );
};

export default SeatGrid;
